<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="surveys">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Encuestas&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                v-if="userType === 1 || userType === 2"
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewSurvey"
                                >Nueva Encuesta</v-btn
                            >
                            <v-btn
                                v-if="userType === 1 || userType === 2"
                                :disabled="bEdit || survey.encuestaID === 0"
                                text
                                class="text-none"
                                @click="onEditSurvey"
                                >Editar Encuesta</v-btn
                            >
                            <v-btn
                                v-if="userType === 1 || userType === 2"
                                :disabled="bEdit || survey.encuestaID === 0"
                                text
                                class="text-none"
                                @click="onDeleteSurvey"
                                >Borrar Encuesta</v-btn
                            >

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item
                                    v-if="userType === 1 || userType === 2"
                                    :disabled="bEdit"
                                    @click="onNewSurvey"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            @click="onNewSurvey"
                                            >mdi-file-plus</v-icon
                                        >&nbsp; Nueva Encuesta
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="userType === 1 || userType === 2"
                                    :disabled="bEdit"
                                    @click="onEditSurvey"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            @click="onEditSurvey"
                                            >mdi-pencil</v-icon
                                        >&nbsp; Editar Encuesta
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="userType === 1 || userType === 2"
                                    :disabled="bEdit"
                                    @click="onDeleteSurvey"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            @click="onDeleteSurvey"
                                            >mdi-delete</v-icon
                                        >&nbsp; Borrar Encuesta
                                    </v-list-item-title>
                                </v-list-item>

                                <v-divider v-if="userType === 1 || userType === 2"></v-divider>

                                <v-list-item
                                    v-if="userType === 1 || userType === 2"
                                    :disabled="bEdit"
                                    @click="onExcelExport"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            >mdi-microsoft-excel</v-icon
                                        >&nbsp; Exportar a Excel
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-if="userType === 1 || userType === 2"
                                    :disabled="bEdit"
                                    @click="onProcessReport"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            >mdi-file-chart-outline</v-icon
                                        >&nbsp; Generar reporte
                                    </v-list-item-title>
                                </v-list-item>

                                <!-- El botón para enviar invitaciones está habilitado si no se está en edición
                                y si el usuario logueado es superadmin o admin de prepago:-->

                                <v-list-item
                                    v-if="!survey.invitacionMandada && (userType === 1 || userType === 2)"
                                    :disabled="bEdit"
                                    @click="onSendSurveyInvitations"
                                >
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1" :disabled="bEdit"
                                            >mdi-email-arrow-right-outline</v-icon
                                        >&nbsp; Enviar invitaciones
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-else-if="!survey.invitacionMandada && userType === 3"
                                >
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-email-arrow-right-outline</v-icon
                                        >&nbsp; Invitaciones no enviadas
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-else>
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1"
                                            >mdi-email-check-outline</v-icon
                                        >&nbsp; Invitaciones enviadas
                                    </v-list-item-title>
                                </v-list-item>

                                <v-divider></v-divider>

                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red" :disabled="bEdit" @click="onClose"
                                            >mdi-close</v-icon
                                        >&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de encuestas y encuesta seleccionada: -->
                    <v-container pa-2 grid-list-md fluid>
                        <!-- Renglón único para lista de encuestas y card de encuesta seleccionada: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de encuestas: *************************** -->
                            <v-flex xs10 sm4 md3>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Encuestas Registradas</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit || loadingSurvey"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedSurveyIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(survey, i) in surveys"
                                                :key="i"
                                                @click="selectSurvey(survey.encuestaID)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>{{
                                                                    survey.nombreEncuesta
                                                                }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Encuestas ********************************* -->

                            <!-- Info de Encuesta seleccionada: *********************** -->
                            <v-flex xs10 sm8 md9>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-icon>mdi-clipboard-pulse-outline</v-icon>
                                        <v-toolbar-title class="my-list-title"
                                            >&nbsp; {{ selectedSurveyName }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-toolbar-items class="hidden-sm-and-down">
                                            <v-tooltip
                                                bottom
                                                v-if="survey.masivaID !== 0 || bMultipleSurvey"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on">mdi-account-group</v-icon>
                                                </template>
                                                <span>Encuesta masiva</span>
                                            </v-tooltip>

                                            <v-tooltip
                                                bottom
                                                v-if="userType === 1 || userType === 2"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        text
                                                        @click="onExcelExport"
                                                        :disabled="bEdit"
                                                        v-on="on"
                                                        color="blue-grey darken-3"
                                                    >
                                                        <v-icon>mdi-microsoft-excel</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Exportar a Excel</span>
                                            </v-tooltip>

                                            <v-tooltip
                                                bottom
                                                v-if="userType === 1 || userType === 2"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        text
                                                        @click="onProcessReport"
                                                        :disabled="bEdit"
                                                        v-on="on"
                                                        color="blue-grey darken-3"
                                                    >
                                                        <v-icon>mdi-file-chart-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Generar reporte</span>
                                            </v-tooltip>

                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        text
                                                        @click="onSendSurveyInvitations"
                                                        :disabled="bEdit || userType === 3"
                                                        v-on="on"
                                                        color="blue-grey darken-3"
                                                    >
                                                        <v-icon v-if="!survey.invitacionMandada">mdi-email-arrow-right-outline</v-icon>
                                                        <v-icon v-else>mdi-email-check-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span v-if="!survey.invitacionMandada && (userType === 1 || userType === 2)">Enviar invitaciones</span>
                                                <!-- <span v-else-if="!survey.invitacionMandada && userType === 3">Las invitaciones no han sido enviadas</span> -->
                                                <span v-else>Las invitaciones ya fueron enviadas</span>
                                            </v-tooltip>
                                        </v-toolbar-items>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row>
                                                <v-flex md12>
                                                    <div class="text-xs-left">
                                                        <span class="teal--text text--darken-3 body-1">
                                                            <v-icon color="teal darken-1"
                                                                >mdi-information-variant</v-icon
                                                            >&nbsp; Información General de la Encuesta
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 sm12 md6>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-clipboard-pulse-outline"
                                                        name="name"
                                                        label="Nombre de la encuesta"
                                                        type="text"
                                                        v-model="survey.nombreEncuesta"
                                                        :readonly="!bEdit"
                                                        ref="name_field"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md2>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-calendar-month"
                                                        name="name"
                                                        label="Fecha de registro"
                                                        type="text"
                                                        v-model="survey.fechaRegistro"
                                                        readonly
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 sm6 md2>
                                                    <v-menu
                                                        v-model="bMenuDateIni"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                        :disabled="!bEdit"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                :dense="bDense"
                                                                color="teal darken-3"
                                                                v-model="survey.fechaInicio"
                                                                label="Fecha de inicio"
                                                                prepend-icon="mdi-calendar-arrow-right"
                                                                readonly
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            color="teal darken-3"
                                                            v-model="survey.fechaInicio"
                                                            @input="bMenuDateIni = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs6 sm6 md2>
                                                    <v-menu
                                                        v-model="bMenuDateEnd"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                        :disabled="!bEdit"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                :dense="bDense"
                                                                color="teal darken-3"
                                                                v-model="survey.fechaCierre"
                                                                label="Fecha de cierre"
                                                                prepend-icon="mdi-calendar-arrow-left"
                                                                readonly
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            color="teal darken-3"
                                                            v-model="survey.fechaCierre"
                                                            @input="bMenuDateEnd = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 sm12 md7>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-domain"
                                                        :items="companies"
                                                        item-text="empresanombre"
                                                        item-value="empresaid"
                                                        v-model="survey.empresaID"
                                                        label="Empresa"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay empresas registradas."
                                                        @change="onSelectCompany"
                                                        :readonly="!bEdit || userType === 2"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-space-around align-center>
                                                <v-flex xs12 md5 class="text-center">
                                                    <img
                                                        :height="logoHeight"
                                                        :src="companyLogoImg"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md5 v-if="!bNew">
                                                    <v-container>
                                                        <v-layout row>
                                                            <v-flex xs12>
                                                                <div class="text-center">
                                                                    <span
                                                                        class="teal--text text--darken-3 body-1"
                                                                        >Avance de la Encuesta</span
                                                                    >
                                                                </div>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12>
                                                                <div class="text-center">
                                                                    <span
                                                                        :class="surveyProgressClass"
                                                                        >{{ survey.numRespuestas }}
                                                                        de
                                                                        {{ survey.usuarios.length }}
                                                                        usuarios</span
                                                                    >
                                                                </div>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs12 class="text-center">
                                                                <v-progress-circular
                                                                    :value="surveyPercentage"
                                                                    :color="progressColor"
                                                                    size="65"
                                                                    width="7"
                                                                    >{{
                                                                        surveyPercentage
                                                                    }}
                                                                    %</v-progress-circular
                                                                >
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <!-- <v-flex xs12 md4 v-if="bNew && !bMultipleSurvey"> -->
                                                <v-flex xs12 md4 v-if="!bMultipleSurvey">
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account"
                                                        label="Evaluado"
                                                        type="text"
                                                        v-model="survey.evaluado"
                                                        :readonly="!bEdit"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md4>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account-star"
                                                        label="Encuesta creada por"
                                                        type="text"
                                                        v-model="surveyCreatorName"
                                                        :readonly="true"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md4>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account-star-outline"
                                                        :items="internalAdministrators"
                                                        item-text="name"
                                                        item-value="userID"
                                                        v-model="survey.adminSegInternoID"
                                                        label="Administrador de seguimiento interno"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        :no-data-text="noDataTextInternalAdmin"
                                                        :readonly="!bEdit"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider class="teal lighten-1"></v-divider>
                                            <br />
                                            <v-layout row>
                                                <v-flex md12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="teal--text text--darken-3 body-1"
                                                        >
                                                            <v-icon color="teal darken-1"
                                                                >mdi-cog</v-icon
                                                            >&nbsp;Configuración de la Encuesta
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-between>
                                                <v-flex xs12 sm12 md6>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-clipboard-list-outline"
                                                        :items="questionnaires"
                                                        item-text="idiomas[0].titulo"
                                                        item-value="id"
                                                        v-model="survey.cuestionarioID"
                                                        label="Cuestionario"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay cuestionarios registrados"
                                                        @change="onSelectQuestionnaire"
                                                        :readonly="
                                                            !bEdit || !bNew || userType === 2
                                                        "
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex v-if="bShowAnswerSet" xs12 sm12 md5>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-check-all"
                                                        label="Set de respuestas"
                                                        type="text"
                                                        v-model="answerSetName"
                                                        readonly
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider v-if="bModules"></v-divider>

                                            <v-layout row v-if="bModules">
                                                <v-flex md12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="teal--text text--darken-3 caption"
                                                        >
                                                            <v-icon color="teal darken-1"
                                                                >mdi-vector-circle</v-icon
                                                            >&nbsp; Módulos:
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap v-if="bModules">
                                                <v-flex
                                                    xs6
                                                    md3
                                                    v-for="questModule in questionnaireModules"
                                                >
                                                    <v-checkbox
                                                        :dense="bDense"
                                                        :readonly="!bEdit"
                                                        :key="questModule.moduleID"
                                                        :label="questModule.module"
                                                        v-model="questModule.selected"
                                                        color="orange accent-4"
                                                        @change="onSelectModule(questModule.moduleID)"
                                                    ></v-checkbox>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider></v-divider>

                                            <v-layout row v-if="survey.cuestionarioID !== 0">
                                                <v-flex md12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="teal--text text--darken-3 caption"
                                                        >
                                                            <v-icon color="teal darken-1"
                                                                >mdi-earth</v-icon
                                                            >&nbsp;Idiomas:
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap v-if="survey.cuestionarioID !== 0">
                                                <v-flex
                                                    xs4
                                                    md3
                                                    v-for="lang in questionnaireLanguages"
                                                >
                                                    <v-checkbox
                                                        :dense="bDense"
                                                        :readonly="!bEdit"
                                                        :key="lang.languageID"
                                                        :label="lang.langName"
                                                        v-model="lang.selected"
                                                        color="orange accent-4"
                                                        @change="onSelectLanguage(lang.languageID)"
                                                    ></v-checkbox>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider></v-divider>

                                            <v-layout row v-if="survey.cuestionarioID !== 0">
                                                <v-flex xs10>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="teal--text text--darken-3 caption"
                                                        >
                                                            <v-icon color="teal darken-1"
                                                                >mdi-flag</v-icon
                                                            >&nbsp;Categorías:
                                                        </span>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs2 class="text-right">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                icon
                                                                @click="onAddCategory()"
                                                                v-on="on"
                                                                :disabled="!bEdit || survey.usuarios.length > 0"
                                                            >
                                                                <v-icon color="orange accent-4"
                                                                    >mdi-flag-plus</v-icon
                                                                >
                                                            </v-btn>
                                                        </template>
                                                        <span>Agregar una categoría</span>
                                                    </v-tooltip>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap v-if="survey.cuestionarioID !== 0">
                                                <v-flex
                                                    xs12
                                                    v-for="(category, i) in survey.categorias"
                                                    :key="i"
                                                >
                                                    <v-card>
                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                        >
                                                            Categoría {{ i + 1 }}
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <!-- Si la encuesta tiene usuarios no se pueden editar las categorías ni los segmentos -->
                                                                    <v-btn
                                                                        icon
                                                                        @click="onEditCategory(category.categoriaID, i + 1)"
                                                                        v-on="on"
                                                                        :disabled="!bEdit || survey.usuarios.length > 0"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                            >mdi-pencil</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </template>
                                                                <span
                                                                    >Editar el nombre de la categoría</span
                                                                >
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        @click="onDeleteCategory(category.categoriaID, i + 1)"
                                                                        v-on="on"
                                                                        :disabled="!bEdit || survey.usuarios.length > 0"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                            >mdi-flag-minus</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </template>
                                                                <span
                                                                    >Borrar la categoría</span
                                                                >
                                                            </v-tooltip>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="categoryHeader"
                                                                :items="categoryNameTable[i]"
                                                                item-key="idiomaID"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No hay nombres para esta categoría."
                                                                :show-select="false"
                                                                single-select
                                                                dense
                                                            >
                                                            </v-data-table>
                                                        </v-card-text>

                                                        <v-card-title
                                                            class="teal--text text--darken-3 body-2 font-weight-bold"
                                                        >
                                                            Cortes
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        @click="onAddSegment(i)"
                                                                        v-on="on"
                                                                        :disabled="!bEdit || survey.usuarios.length > 0"
                                                                    >
                                                                        <v-icon color="orange accent-4"
                                                                            >mdi-plus-thick</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </template>
                                                                <span>Agregar un corte</span>
                                                            </v-tooltip>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="segmentHeader"
                                                                :items="categorySegmentTable[i]"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No hay cortes para esta categoría."
                                                                :show-select="false"
                                                                :items-per-page="(typeof(categorySegmentTable[i]) !== 'undefined') ? (categorySegmentTable[i].length) : 0"
                                                            >
                                                                <template
                                                                    v-slot:item.editBtn="props"
                                                                >
                                                                    <v-tooltip bottom>
                                                                        <template
                                                                            v-slot:activator="{ on }"
                                                                        >
                                                                            <v-btn
                                                                                icon
                                                                                @click="onEditSegment(category, props.item)"
                                                                                v-on="on"
                                                                                :disabled="!bEdit || survey.usuarios.length > 0"
                                                                            >
                                                                                <v-icon
                                                                                    color="orange accent-4"
                                                                                    >mdi-pencil</v-icon
                                                                                >
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Editar el corte</span>
                                                                    </v-tooltip>
                                                                </template>
                                                                <template
                                                                    v-slot:item.deleteBtn="props"
                                                                >
                                                                    <v-tooltip bottom>
                                                                        <template
                                                                            v-slot:activator="{ on }"
                                                                        >
                                                                            <v-btn
                                                                                icon
                                                                                @click="onDeleteSegment(category, i, props.item)"
                                                                                v-on="on"
                                                                                :disabled="!bEdit || survey.usuarios.length > 0"
                                                                            >
                                                                                <v-icon
                                                                                    color="orange accent-4"
                                                                                    >mdi-trash-can</v-icon
                                                                                >
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Borrar el corte</span>
                                                                    </v-tooltip>
                                                                </template>
                                                            </v-data-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider v-if="bEnvioReporte"></v-divider>

                                            <v-layout row v-if="bEnvioReporte">
                                                <v-flex md12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="teal--text text--darken-3 caption"
                                                        >
                                                            <v-icon color="teal darken-1"
                                                                >mdi-email-arrow-right-outline</v-icon
                                                            >&nbsp;Envío de reporte:
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row v-if="bEnvioReporte">
                                                <v-flex xs12>
                                                    <v-radio-group
                                                        dense
                                                        v-model="survey.envioMailReporte"
                                                        row
                                                        :mandatory="true"
                                                    >
                                                        <v-radio
                                                            label="Sólo al usuario"
                                                            value="0"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="Al administrador de seguimiento interno"
                                                            value="1"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="A ambos"
                                                            value="2"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="A ninguno"
                                                            value="3"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider></v-divider>

                                            <v-layout row>
                                                <v-flex md12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="teal--text text--darken-3 caption"
                                                        >
                                                            <v-icon color="teal darken-1"
                                                                >mdi-cog-box</v-icon
                                                            >&nbsp;Configuración Adicional:
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-flex xs6 md3 v-if="bAllowMultipleSurvey">
                                                    <v-checkbox
                                                        :dense="bDense"
                                                        :readonly="!bEdit"
                                                        :disabled="bEdit && !bNew"
                                                        label="Encuesta Masiva"
                                                        v-model="bMultipleSurvey"
                                                        color="orange accent-4"
                                                    ></v-checkbox>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 md5>
                                                    <v-container pa-0>
                                                        <v-layout row wrap>
                                                            <v-flex xs10>
                                                                <v-checkbox
                                                                    :dense="bDense"
                                                                    :readonly="!bEdit"
                                                                    label="Mandar estados cada:"
                                                                    v-model="survey.mandarEstados"
                                                                    color="orange accent-4"
                                                                    @change="onSendStatus"
                                                                ></v-checkbox>
                                                            </v-flex>
                                                            <v-flex
                                                                xs2
                                                                class="d-flex justify-md-start"
                                                            >
                                                                <v-text-field
                                                                    :dense="bDense"
                                                                    color="teal darken-3"
                                                                    label="días"
                                                                    v-model="survey.mandarEstadosDias"
                                                                    :readonly="!bEdit"
                                                                    :disabled="!survey.mandarEstados"
                                                                    reverse
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                                <v-flex xs12 md5 offset-md1>
                                                    <v-container pa-0>
                                                        <v-layout row justify-space-between>
                                                            <v-flex xs10>
                                                                <v-checkbox
                                                                    :dense="bDense"
                                                                    :readonly="!bEdit"
                                                                    label="Mandar recordatorios cada:"
                                                                    v-model="survey.mandarRecordatorios"
                                                                    color="orange accent-4"
                                                                    @change="onSendReminders"
                                                                ></v-checkbox>
                                                            </v-flex>
                                                            <v-flex xs2 class="d-flex justify-md-start">
                                                                <v-text-field
                                                                    :dense="bDense"
                                                                    color="teal darken-3"
                                                                    label="días"
                                                                    v-model="survey.mandarRecordatoriosDias"
                                                                    :readonly="!bEdit"
                                                                    :disabled="!survey.mandarRecordatorios"
                                                                    reverse
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs9 md9 lg6>
                                                    <v-checkbox
                                                        :dense="bDense"
                                                        :readonly="!bEdit"
                                                        label="Mostrar demográficos en reporte sólo si hay al menos:"
                                                        v-model="survey.mostrarDemograficos"
                                                        color="orange accent-4"
                                                         @change="onShowDemographics"
                                                    ></v-checkbox>
                                                </v-flex>
                                                <v-flex xs3 md2 lg2 class="d-flex justify-md-start">
                                                    <v-text-field
                                                        :dense="bDense"
                                                        color="teal darken-3"
                                                        label="Usuarios"
                                                        v-model="survey.minimoDemograficos"
                                                        :readonly="!bEdit"
                                                        :disabled="!survey.mostrarDemograficos"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-space-around>
                                                <v-flex xs12>
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        v-model="survey.textoInvitacion"
                                                        :auto-grow="false"
                                                        no-resize
                                                        color="teal darken-3"
                                                        append-icon="mdi-email"
                                                        background-color="teal lighten-5"
                                                        label="Mensaje del correo de invitación"
                                                        rows="8"
                                                        :readonly="!bEdit"
                                                        counter="1000"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Los siguientes botones de OK y Cancelar se deben mostrar cuando se está registrando una encuesta nueva no masiva
                                            o cuando se está editando cualquier encuesta (masiva o no):-->
                                            <!--  -->
                                            <v-layout
                                                v-if="
                                                    (bNew && !bMultipleSurvey) || (!bNew && bEdit)
                                                "
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        >OK</v-btn
                                                    >
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        >Cancelar</v-btn
                                                    >
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-card>
                                                        <!-- color="teal lighten-4" -->
                                                        <v-toolbar
                                                            dense
                                                            color="blue-grey darken-1"
                                                            flat
                                                            dark
                                                        >
                                                            <v-icon>mdi-account-multiple</v-icon>
                                                            <v-toolbar-title class="my-list-title"
                                                                >&nbsp; Usuarios de la Encuesta</v-toolbar-title
                                                            >
                                                            <v-spacer></v-spacer>

                                                            <v-toolbar-items
                                                                v-if="
                                                                    userType === 1 || userType === 2
                                                                "
                                                                class="hidden-sm-and-down"
                                                            >
                                                                <!-- Los botones OK y Cancelar se deshabilitan si se está registrando una encuesta nueva no masiva,
                                                                ya que los usuarios para una encuesta no masiva se agregan sólo cuando la encuesta ya fue guardada.
                                                                
                                                                También se deben deshabilitar si se está editando una encuesta no nueva, sea masiva o no.-->

                                                                <v-menu offset-y>
                                                                    <template
                                                                        v-slot:activator="{ on }"
                                                                    >
                                                                        <v-btn
                                                                            text
                                                                            class="text-none"
                                                                            v-on="on"
                                                                            :disabled="
                                                                                (bNew &&
                                                                                    !bMultipleSurvey) ||
                                                                                (bEdit && !bNew)
                                                                            "
                                                                            >Usuarios</v-btn
                                                                        >
                                                                    </template>
                                                                    <v-list color="grey lighten-5">
                                                                        <v-list-item
                                                                            :disabled="
                                                                                bEdit &&
                                                                                !bMultipleSurvey
                                                                            "
                                                                            @click="onImportUsers"
                                                                        >
                                                                            <v-list-item-title>
                                                                                <v-icon
                                                                                    color="blue-grey darken-1"
                                                                                    :disabled="
                                                                                        bEdit &&
                                                                                        !bMultipleSurvey
                                                                                    "
                                                                                    >mdi-account-multiple-plus</v-icon
                                                                                >&nbsp; Importar
                                                                            </v-list-item-title>
                                                                        </v-list-item>
                                                                        <v-list-item
                                                                            :disabled="
                                                                                bEdit &&
                                                                                !bMultipleSurvey
                                                                            "
                                                                            @click="onAddUser"
                                                                        >
                                                                            <v-list-item-title>
                                                                                <v-icon
                                                                                    color="blue-grey darken-1"
                                                                                    :disabled="
                                                                                        bEdit &&
                                                                                        !bMultipleSurvey
                                                                                    "
                                                                                    >mdi-account-plus</v-icon
                                                                                >&nbsp; Agregar
                                                                            </v-list-item-title>
                                                                        </v-list-item>

                                                                        <v-divider></v-divider>

                                                                        <v-list-item
                                                                            :disabled="
                                                                                (bEdit &&
                                                                                    !bMultipleSurvey) ||
                                                                                selectedUser.length ===
                                                                                    0
                                                                            "
                                                                            @click="onEditUser"
                                                                        >
                                                                            <v-list-item-title>
                                                                                <v-icon
                                                                                    color="blue-grey darken-1"
                                                                                    :disabled="
                                                                                        (bEdit &&
                                                                                            !bMultipleSurvey) ||
                                                                                        selectedUser.length ===
                                                                                            0
                                                                                    "
                                                                                    >mdi-account-edit</v-icon
                                                                                >&nbsp; Editar
                                                                            </v-list-item-title>
                                                                        </v-list-item>

                                                                        <v-list-item
                                                                            :disabled="
                                                                                (bEdit &&
                                                                                    !bMultipleSurvey) ||
                                                                                selectedUser.length ===
                                                                                    0
                                                                            "
                                                                            @click="onDeleteUser"
                                                                        >
                                                                            <v-list-item-title>
                                                                                <v-icon
                                                                                    color="blue-grey darken-1"
                                                                                    :disabled="
                                                                                        (bEdit &&
                                                                                            !bMultipleSurvey) ||
                                                                                        selectedUser.length ===
                                                                                            0
                                                                                    "
                                                                                    >mdi-account-remove</v-icon
                                                                                >&nbsp; Borrar
                                                                            </v-list-item-title>
                                                                        </v-list-item>

                                                                        <v-divider></v-divider>

                                                                        <v-list-item
                                                                            @click="
                                                                                onChangePassword
                                                                            "
                                                                            :disabled="
                                                                                bEdit ||
                                                                                selectedUser.length ===
                                                                                    0
                                                                            "
                                                                        >
                                                                            <v-list-item-title>
                                                                                <v-icon
                                                                                    color="blue-grey darken-1"
                                                                                    :disabled="
                                                                                        bEdit ||
                                                                                        selectedUser.length ===
                                                                                            0
                                                                                    "
                                                                                    >mdi-pencil-lock</v-icon
                                                                                >&nbsp; Regenerar
                                                                                contraseña
                                                                            </v-list-item-title>
                                                                        </v-list-item>

                                                                        <v-list-item
                                                                            @click="
                                                                                onSendUserInvitation
                                                                            "
                                                                            :disabled="
                                                                                bEdit ||
                                                                                selectedUser.length ===
                                                                                    0
                                                                            "
                                                                        >
                                                                            <v-list-item-title>
                                                                                <v-icon
                                                                                    color="blue-grey darken-1"
                                                                                    :disabled="
                                                                                        bEdit ||
                                                                                        selectedUser.length ===
                                                                                            0
                                                                                    "
                                                                                    >mdi-email-arrow-right-outline</v-icon
                                                                                >&nbsp; Enviar
                                                                                invitación
                                                                            </v-list-item-title>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-menu>
                                                            </v-toolbar-items>

                                                            <!-- Menú lateral para dispositivos con ventanas chicas: -->
                                                            <v-menu
                                                                offset-y
                                                                v-if="
                                                                    userType === 1 || userType === 2
                                                                "
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        v-on="on"
                                                                        class="hidden-md-and-up"
                                                                    >
                                                                        <v-icon
                                                                            >mdi-dots-vertical</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </template>
                                                                <v-list color="grey lighten-4">
                                                                    <v-list-item
                                                                        :disabled="
                                                                            bEdit &&
                                                                            !bMultipleSurvey
                                                                        "
                                                                        @click="onImportUsers"
                                                                    >
                                                                        <v-list-item-title>
                                                                            <v-icon
                                                                                color="blue-grey darken-1"
                                                                                :disabled="
                                                                                    bEdit &&
                                                                                    !bMultipleSurvey
                                                                                "
                                                                                >mdi-account-multiple-plus</v-icon
                                                                            >&nbsp; Importar
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                    <v-list-item
                                                                        :disabled="
                                                                            bEdit &&
                                                                            !bMultipleSurvey
                                                                        "
                                                                        @click="onAddUser"
                                                                    >
                                                                        <v-list-item-title>
                                                                            <v-icon
                                                                                color="blue-grey darken-1"
                                                                                :disabled="
                                                                                    bEdit &&
                                                                                    !bMultipleSurvey
                                                                                "
                                                                                >mdi-account-plus</v-icon
                                                                            >&nbsp; Agregar
                                                                        </v-list-item-title>
                                                                    </v-list-item>

                                                                    <v-divider></v-divider>

                                                                    <v-list-item
                                                                        :disabled="
                                                                            (bEdit &&
                                                                                !bMultipleSurvey) ||
                                                                            selectedUser.length ===
                                                                                0
                                                                        "
                                                                        @click="onEditUser"
                                                                    >
                                                                        <v-list-item-title>
                                                                            <v-icon
                                                                                color="blue-grey darken-1"
                                                                                :disabled="
                                                                                    (bEdit &&
                                                                                        !bMultipleSurvey) ||
                                                                                    selectedUser.length ===
                                                                                        0
                                                                                "
                                                                                >mdi-account-edit</v-icon
                                                                            >&nbsp; Editar
                                                                        </v-list-item-title>
                                                                    </v-list-item>

                                                                    <v-list-item
                                                                        :disabled="
                                                                            (bEdit &&
                                                                                !bMultipleSurvey) ||
                                                                            selectedUser.length ===
                                                                                0
                                                                        "
                                                                        @click="onDeleteUser"
                                                                    >
                                                                        <v-list-item-title>
                                                                            <v-icon
                                                                                color="blue-grey darken-1"
                                                                                :disabled="
                                                                                    (bEdit &&
                                                                                        !bMultipleSurvey) ||
                                                                                    selectedUser.length ===
                                                                                        0
                                                                                "
                                                                                >mdi-account-remove</v-icon
                                                                            >&nbsp; Borrar
                                                                        </v-list-item-title>
                                                                    </v-list-item>

                                                                    <v-divider></v-divider>

                                                                    <v-list-item
                                                                        @click="onChangePassword"
                                                                        :disabled="
                                                                            bEdit ||
                                                                            selectedUser.length ===
                                                                                0
                                                                        "
                                                                    >
                                                                        <v-list-item-title>
                                                                            <v-icon
                                                                                color="blue-grey darken-1"
                                                                                :disabled="
                                                                                    bEdit ||
                                                                                    selectedUser.length ===
                                                                                        0
                                                                                "
                                                                                >mdi-pencil-lock</v-icon
                                                                            >&nbsp; Regenerar
                                                                            contraseña
                                                                        </v-list-item-title>
                                                                    </v-list-item>

                                                                    <v-list-item
                                                                        @click="
                                                                            onSendUserInvitation
                                                                        "
                                                                        :disabled="
                                                                            bEdit ||
                                                                            selectedUser.length ===
                                                                                0
                                                                        "
                                                                    >
                                                                        <v-list-item-title>
                                                                            <v-icon
                                                                                color="blue-grey darken-1"
                                                                                :disabled="
                                                                                    bEdit ||
                                                                                    selectedUser.length === 0"
                                                                                >mdi-email-arrow-right-outline</v-icon
                                                                            >&nbsp; Enviar
                                                                            invitación
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-toolbar>

                                                        <v-data-table
                                                            fixed-header
                                                            :headers="userTableHeader"
                                                            :items="surveyUserTable"
                                                            item-key="usuarioID"
                                                            v-model="selectedUser"
                                                            locale="es-MX"
                                                            :hide-default-footer="
                                                                surveyUserTable.length < 11
                                                            "
                                                            :show-select="
                                                                !bEdit &&
                                                                (userType === 1 || userType === 2)
                                                            "
                                                            :single-select="true"
                                                            dense
                                                            no-data-text="No hay usuarios registrados en esta encuesta."
                                                            :items-per-page="10"
                                                            :footer-props="{
                                                                'items-per-page-text':
                                                                    'Usuarios por página:',
                                                                'items-per-page-all-text': 'Todos',
                                                            }"
                                                        >
                                                            <template v-slot:item.controls="props">
                                                                <v-checkbox
                                                                    dense
                                                                    :readonly="userType === 3"
                                                                    v-model="props.item.reporte"
                                                                    color="orange accent-4"
                                                                    label="Incluir"
                                                                ></v-checkbox>
                                                            </template>
                                                        </v-data-table>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Los siguentes botones de OK y Cancelar sólo se muestran si se está registrando una nueva encuesta masiva: -->
                                            <v-layout
                                                v-if="bNew && bMultipleSurvey"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        >OK</v-btn
                                                    >
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        >Cancelar</v-btn
                                                    >
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de Encuesta seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para editar un usuario: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditUser" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title v-if="bNewUser" class="my-list-title"
                                            >Agregar usuario número
                                            {{ editingUserNumber }}</v-toolbar-title
                                        >
                                        <v-toolbar-title v-else class="my-list-title"
                                            >Editar usuario número
                                            {{ editingUserNumber }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-account-edit</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account"
                                                        label="Nombre"
                                                        type="text"
                                                        v-model="editingUserName"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-email-outline"
                                                        label="Correo electrónico"
                                                        type="text"
                                                        required
                                                        v-model="editingUserEmail"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-card-account-details-star"
                                                        :items="surveyRolleLabels"
                                                        item-text="label"
                                                        item-value="rolleID"
                                                        v-model="editingUserRolleID"
                                                        label="Tipo de usuario"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay roles registrados."
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Si el usuario es colectivo se pide que se especifique el número de accesos: -->
                                            <v-layout v-if="editingUserRolleID === 2" row>
                                                <v-flex xs12 sm10 md4>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account-multiple"
                                                        label="Número de accesos"
                                                        type="number"
                                                        v-model="editingUserAccessNumber"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-checkbox
                                                        :dense="bDense"
                                                        label="Incluir en el reporte"
                                                        v-model="editingUserReport"
                                                        color="orange accent-4"
                                                    ></v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmUserEdition"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCanceUserEdition"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar un usuario *************************** -->

                        <!-- Modal para confirmar borrado de Usuario: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingUser" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar Usuario</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al usuario "{{ deletingUserName }}"?
                                    </v-card-title>
                                    <v-card-text class="text-center"
                                        >Esta acción no se puede deshacer.</v-card-text
                                    >
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmDeleteUser"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelDeleteUser"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de Usuario *************************** -->

                        <!-- Modal para para confirmar cambio de password de un usuario: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bChangingUserPasswd" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Cambiar contraseña de usuario</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-lock</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2"
                                                >mdi-pencil-lock</v-icon
                                            >
                                        </div>
                                        &nbsp; ¿Desea regenerar la contraseña del usuario "{{
                                            changePasswdUserName
                                        }}"?
                                    </v-card-title>
                                    <v-card-text class="text-center"
                                        >Esta acción no se puede deshacer.</v-card-text
                                    >
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmChangePassword"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelChangePassword"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar cambio de password de un usuario *************************** -->

                        <!-- Modal para para confirmar procesamiento de reporte: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bProcessReportDlg" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Procesar reporte</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-file-chart-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="red"
                                                >mdi-file-pdf-box</v-icon
                                            >
                                        </div>
                                        Seleccione un idioma para generar el reporte:
                                        <v-container fluid>
                                            <v-layout row align-center>
                                                <v-flex fill-height xs12 md10 sm8>
                                                    <v-radio-group
                                                        dense
                                                        v-model="reportLanguageID"
                                                        row
                                                        :mandatory="true"
                                                    >
                                                        <v-radio
                                                            label="Español"
                                                            value="1"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="Inglés"
                                                            value="2"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmProcessReport"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelProcessReport"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar procesamiento de reporte *************************** -->

                        <!-- Modal para informar que no se pudo procesar el reporte *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bReportNotCreated"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Reporte no generado</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >No se pudo generar el reporte.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bReportNotCreated = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no se pudo procesar el reporte *********************************** -->

                        <!-- Modal para informar que no el autorretroalimentado no ha contestado *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bNotMainUserAnswer"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >El usuario retroalimentado no ha
                                            contestado</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >El usuario retroalimentado no ha contestado.
                                                    ¿Desea generar un reporte hipotético?</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onHypotheticalReport"
                                            >Sí</v-btn
                                        >
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bNotMainUserAnswer = false"
                                            >No</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no el autorretroalimentado no ha contestado *********************************** -->

                        <!-- Modal para para confirmar exportación a Excel: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bExcelExportDlg" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Exportar a Excel</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-microsoft-excel</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="teal darken-1"
                                                >mdi-microsoft-excel</v-icon
                                            >
                                        </div>
                                        ¿Desea exportar los resultados de esta encuesta a Excel?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmExcelExport"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelExcelExport"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar exportación a Excel *************************** -->

                        <!-- Modal para informar que no se pudo procesar el reporte en Excel*********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bExcelNotCreated"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Reporte en Excel no generado</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >No se pudo generar el reporte en Excel.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bExcelNotCreated = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no se pudo procesar el reporte en Excel*********************************** -->

                        <!-- Modal para para confirmar envío de invitación a un usuario de la encuesta: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bSendingUserInvitation" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Enviar invitación a usuario</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2"
                                                >mdi-email-send</v-icon
                                            >
                                        </div>
                                        &nbsp; ¿Desea enviar una invitación al usuario
                                        {{ sendInvitationUserName }}"?
                                    </v-card-title>
                                    <v-card-text class="text-center"
                                        >Esta acción no se puede deshacer.</v-card-text
                                    >
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSendUserInvitation"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSendUserInvitation"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar envío de invitación a un usuario de la encuesta *************************** -->

                        <!-- Modal para para confirmar envío de invitaciones de encuesta: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bSendingSurveyInvitations" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Enviar invitaciones</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2"
                                                >mdi-email-send</v-icon
                                            >
                                        </div>
                                        &nbsp; ¿Desea enviar las invitaciones de la encuesta"?
                                    </v-card-title>
                                    <v-card-text class="text-center"
                                        >Esta acción no se puede deshacer.</v-card-text
                                    >
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSendSurveyInvitations"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSendSurveyInvitations"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar envío de invitaciones de encuesta *************************** -->

                        <!-- Modal para cargar archivo de Excel para importar usuarios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bImportUsersDlg" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Importar Usuarios</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-cloud-upload</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-file-input
                                                        color="teal darken-3"
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                        show-size
                                                        label="Cargue un archivo de Excel con los usuario a importar..."
                                                        v-model="importUsersFile"
                                                        >Archivo con usuarios a
                                                        importar</v-file-input
                                                    >
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onUploadImportUsersFile"
                                            >OK</v-btn
                                        >

                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelUploadImportUsersFile"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Modal para cargar archivo de Excel para importar usuarios *************************** -->

                        <!-- Modal para informar que se debe seleccionar un archivo para la importación de usuarios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bShowNullFileAlert"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Importar Usuarios</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >Debe seleccionar un archivo de MS Excel para
                                                    poder importar usuarios.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNullFileAlert = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que se debe seleccionar un archivo para el nuevo cuestionario *********************************** -->

                        <!-- Modal para agregar una categoría: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgAddCategory" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Categoría {{ survey.categorias.length + 1 }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-flag-plus</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                v-for="(categoryName, i) in categoryToEdit"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="categoryName.idioma"
                                                        type="text"
                                                        required
                                                        v-model="categoryName.categoria"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmAddCategory"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelAddCategory"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para agregar una categoría *************************** -->

                        <!-- Modal para editar una categoría: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditCategory" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Categoría {{ editingCategoryNumber }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                v-for="(categoryName, i) in categoryToEdit"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="categoryName.idioma"
                                                        type="text"
                                                        required
                                                        v-model="categoryName.categoria"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmEditCategory"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelEditCategory"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar una categoría *************************** -->

                        <!-- Modal para confirmar borrado de una categoría: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgDeletingCategory" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar Categoría</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-flag-minus</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la categoría {{ deletingCategoryNumber }}?
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmDeleteCategory"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelDeleteCategory"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de una categoría *************************** -->

                        <!-- Modal para agregar un corte: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgAddSegment" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Corte {{ editingSegmentNumber }} de Categoría {{ editingCategoryNumber + 1 }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-plus</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                v-for="(segmentName, i) in segmentToEdit"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="segmentName.idioma"
                                                        type="text"
                                                        required
                                                        v-model="segmentName.segmento"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmAddSegment"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelAddSegment"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para agregar un corte *************************** -->

                        <!-- Modal para editar un corte: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditSegment" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Corte {{ editingSegmentNumber }} de Categoría {{ editingCategoryNumber + 1 }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                v-for="(segmentName, i) in segmentToEdit"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="segmentName.idioma"
                                                        type="text"
                                                        required
                                                        v-model="segmentName.segmento"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmEditSegment"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelEditSegment"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar un corte *************************** -->

                        <!-- Modal para confirmar borrado de un corte: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgDeletingSegment" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar Corte</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-trash-can</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el corte {{ deletingSegmentNumber }} de la Categoría {{ editingCategoryNumber}}?
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmDeleteSegment"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelDeleteSegment"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de un segmento *************************** -->

                        <!-- Modal para confirmar borrado de Encuesta: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingSurvey" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar Encuesta</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la encuesta "{{
                                            survey.nombreEncuesta
                                        }}"?
                                    </v-card-title>
                                    <v-card-text class="text-center"
                                        >Esta acción no se puede deshacer.</v-card-text
                                    >
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteSurveyConfirmed"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteSurvey"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de Ecuesta *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Búsqueda de Encuestas</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>search</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >warning</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center"
                                                    >No hay encuestas registradas con ese
                                                    nombre.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Información no válida</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex xs11 class="justify-center text-center">{{
                                                    errorMessage
                                                }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Termina renglón único para lista de Sets de Respuestas y set seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de Sets de Respuestas y set seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'surveys',
    data() {
        return {
            bDense: false,
            drawer: false,
            bEdit: false,
            bNew: false,
            bNewUser: false,

            bInvalidData: false,
            errorMessage: '',

            bAllowMultipleSurvey: false, //Indica si el cuestionario seleccionado permite encuestas masivas.
            bMultipleSurvey: false, //Encuesta masiva.
            bEnvioReporte: false, //Indica si el cuestionario seleccionado permite opciones de configuración de envío de reportes.
            bReportNotCreated: false, //Indica si el reporte no se pudo generar por algún error.
            bNotMainUserAnswer: false, //Indica que el aurorretroalimentado no ha contestado. Sirve para preguntar si aún así se desea generar el reporte.
            bExcelNotCreated: false, //Indica que el reporte en Excel no se pudo generar.

            bModules: false, //Indica si el cuestionario seleccionado usa módulos.
            //bDlgNewSurvey: false,

            bMenuDateIni: false,
            bMenuDateEnd: false,

            bDeletingSurvey: false,

            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            editingRolle: '', //Rol cuya etiqueta se va a editar.
            rolleLabel: '', //Etiqueta del rol a editar.
            editingRolleID: '', //Identificador del rol a editar (es un string).
            editingRolleObjectName: '', //Campo del nombre del rol en el objeto del arreglo de roles, para identificar cuál etiqueta se editó.

            bDlgEditUser: false,
            editingUserID: 0,
            editingUserNumber: '',
            editingUserName: '',
            editingUserEmail: '',
            editingUserRolleID: 0,
            editingUserAccessNumber: 0,
            editingUserReport: false,
            bDeletingUser: false,
            deletingUserName: '',
            deletingUserID: 0,

            //Campos de la encuesta de soporte, no de la BD:
            answerSetID: 0,
            answerSetName: '',
            selectedSurveyName: '',
            surveyCreatorName: '',

            bShowAnswerSet: false, //Indica si el campo para el set de respuestas se debe mostrar o no.
            questionnaireLanguages: [], //Arreglo con todos los idiomas del cuestionario seleccionado.
            questionnaireModules: [], //Arreglo con todos los módulos del cuestionario seleccionado.
            selectedLabel: [],

            importUsersFile: null, //Archivo cargado por el file input, para importar usuarios.
            bShowNullFileAlert: false,
            bImportUsersDlg: false,

            changePasswdUserID: 0,
            changePasswdUserName: '',
            bChangingUserPasswd: false,

            sendInvitationUserID: 0,
            sendInvitationUserName: '',
            bSendingUserInvitation: false,

            bSendingSurveyInvitations: false,

            bProcessReportDlg: false,
            reportLanguageID: '1', //'1' = Español, '2' = Inglés.

            bExcelExportDlg: false,

            labelTableHeader: [
                {
                    text: '',
                    value: 'rolleID',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                    divider: true,
                },
                {
                    text: 'Rol',
                    value: 'rolle',
                    sortable: false,
                    width: '44%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Etiqueta',
                    value: 'label',
                    sortable: false,
                    width: '44%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: '',
                    value: 'controls',
                    sortable: false,
                    width: '5%',
                    divider: true,
                    align: 'center',
                },
            ],

            userTableHeader: [
                {
                    text: '',
                    value: 'num',
                    sortable: true,
                    width: '1%',
                    align: 'center',
                    divider: true,
                },
                {
                    text: 'Nombre',
                    value: 'nombre',
                    sortable: true,
                    width: '25%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Correo electrónico',
                    value: 'correo',
                    sortable: true,
                    width: '25%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Tipo de usuario',
                    value: 'rol',
                    sortable: true,
                    width: '24%',
                    align: 'center',
                    divider: true,
                },
                {
                    text: 'Estado',
                    value: 'estado',
                    sortable: true,
                    width: '8%',
                    align: 'center',
                    divider: true,
                },
                {
                    text: 'Accesos',
                    value: 'accesos',
                    sortable: false,
                    width: '2%',
                    align: 'end',
                    divider: true,
                },
                {
                    text: 'Contraseña',
                    value: 'password',
                    sortable: false,
                    width: '10%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Reporte',
                    value: 'controls',
                    sortable: false,
                    width: '5%',
                    divider: true,
                }
            ],
            selectedUser: [],

            //Temporal:
            //surveyCategories: [],
            categoryHeader: [],
            //categoryTable: [],
            segmentHeader: [],
            categorySegmentTable: [],
            bDlgAddCategory: false,
            categoryToEdit: [],
            categoryToEditTemplate: [], //Plantilla original
            categoryNameTable: [],
            editingCategoryID: 0,
            editingCategoryNumber: 0,
            bDlgEditCategory: false,
            bDlgDeletingCategory: false,
            deletingCategoryID: 0,
            deletingCategoryNumber: 0,

            segmentToEdit: [],
            segmentToEditTemplate: [],
            bDlgAddSegment: false,
            bDlgDeletingSegment: false,
            editingSegmentID: 0,
            editingSegmentNumber: 0,
            bDlgEditSegment: false,
            deletingSegmentID: 0,
            deletingSegmentNumber: 0,

        };
    },
    created() {
        this.pdfPath = '';
        console.log('pdfPath = ', this.pdfPath);
        console.log('reportProcessed = ', this.reportProcessed);

        this.$store.dispatch('initSurveyData'); //Se inicializan los campos de la encuesta.
        this.selectFirstSurvey();
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        onImportUsers() {
            this.bImportUsersDlg = true;
        },
        onUploadImportUsersFile() {
            if (this.importUsersFile === null) {
                this.bShowNullFileAlert = true;
            } else {
                this.bImportUsersDlg = false;
                console.log('importUsersFile = ', this.importUsersFile);

                //Si la encuesta no está en edición y no es masiva se importan los usuarios a una encuesta ya
                //guardada anteriormente:
                if (!this.bEdit && !this.bMultipleSurvey) {
                    var usersToImport = {
                        surveyID: this.survey.encuestaID,
                        file: this.importUsersFile,
                    };
                    this.$store.dispatch('importSurveyUsers', usersToImport);
                }
                //Si la encuesta es masiva (y es nueva y se está editando), se manda el archivo de Excel
                //al servidor para que el servidor los regrese y temporalmente se puedan ver antes de guardar
                //la encuesta:
                else {
                    if (this.bEdit && this.bMultipleSurvey) {
                        this.$store.dispatch('importMultipleSurveyUsers', this.importUsersFile);
                    }
                }
            }
        },
        onCancelUploadImportUsersFile() {
            this.bImportUsersDlg = false;
        },
        onNewSurvey() {
            this.bMultipleSurvey = false;
            this.bAllowMultipleSurvey = false;

            this.bEdit = true;
            this.bNew = true;

            this.selectedSurveyName = 'Nueva Encuesta';
            this.selectedSurveyIndex = -1;

            this.$store.dispatch('initSurveyData');
            //this.$store.dispatch('updateSurveyRolleLabels', this.survey.alias);

            this.survey.adminCreadorID = this.loggedUserID;
            this.getSurveyCreatorName();

            this.answerSetID = 0;
            this.answerSetName = '';
            this.questionnaireLanguages = [];
            this.questionnaireModules = [];

            this.survey.fechaRegistro = new Date().toISOString().substr(0, 10);
            this.survey.fechaInicio = new Date().toISOString().substr(0, 10);
            this.survey.fechaCierre = new Date().toISOString().substr(0, 10);

            this.companyLogoImg = require('@/assets/no-logo.png');

            //Si el usuario es administrador de encuestas pre-pagadas, se selecciona su empresa y su cuestionario:
            if (this.userType === 2) {
                this.survey.empresaID = this.companyID;
                this.survey.cuestionarioID = this.questionnaireID;

                this.onSelectCompany();
                this.onSelectQuestionnaire();
            }

            this.$refs.name_field.focus();

            console.log('survey = ', this.survey);

            this.categoryNameTable = [];
            this.categorySegmentTable = [];
        },

        onDeleteSurvey() {
            this.bDeletingSurvey = true;
        },
        cancelDeleteSurvey() {
            this.bDeletingSurvey = false;
        },
        deleteSurveyConfirmed() {
            this.bDeletingSurvey = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.surveys.length; i++) {
                if (this.surveys[i].encuestaID === this.survey.encuestaID) {
                    this.surveys.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteSurvey', this.survey.encuestaID);
            this.selectFirstSurvey();
        },
        onEditSurvey() {
            this.bEdit = true;
        },
        onCancel() {
            if (this.bNew) {
                this.bMultipleSurvey = false;

                //Selecciona la primera encuesta de la lista:
                this.selectFirstSurvey();
                this.bNew = false;
            } else {
                //Vuelve a obtener todas las encuestas:
                this.$store.dispatch('fetchSurveys');
                this.selectSurvey(this.survey.encuestaID);
            }
            this.bEdit = false;
        },
        onSave() {
            var bDataOK = false;
            const dtToday = new Date().toISOString().substr(0, 10);

            console.log('survey to Save = ', this.survey);

            //Validación de los datos:
            if (this.survey.nombreEncuesta === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el nombre de la encuesta.';
            }
            else if (this.survey.empresaID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione una empresa.';
            }
            else if (this.survey.evaluado === '' && !this.bMultipleSurvey)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el nombre de la persona evaluada.';
            }
            else if (this.survey.cuestionarioID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione un cuestionario.';
            }
            else if (this.survey.idiomas.length === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione al menos un idioma.';
            }
            else
            if (this.survey.fechaInicio > this.survey.fechaCierre)
            {
                this.bInvalidData = true;
                this.errorMessage = 'La fecha de cierre no puede ser anterior a la fecha de inicio.';
            }
            else if (this.survey.fechaCierre < dtToday)
            {
                this.bInvalidData = true;
                this.errorMessage = 'La fecha de cierre no puede ser antes del día de hoy.';
            }
            else if (this.survey.mandarEstados && (this.survey.mandarEstadosDias < 1 || isNaN(this.survey.mandarEstadosDias)))
            {
                this.bInvalidData = true;
                this.errorMessage = 'El número de días para mandar los estados no es válido.';
            }
            else if (this.survey.mandarRecordatorios && (this.survey.mandarRecordatoriosDias < 1 || isNaN(this.survey.mandarRecordatoriosDias)))
            {
                this.bInvalidData = true;
                this.errorMessage = 'El número de días para mandar los recordatorios no es válido.';
            }
            else if (this.survey.mostrarDemograficos && (this.survey.minimoDemograficos < 1 || isNaN(this.survey.minimoDemograficos)))
            {
                this.bInvalidData = true;
                this.errorMessage = 'El número de usuarios que se requieren para mostrar demográficos en el reporte no es válido.';
            }
            else if (this.bNew && this.bMultipleSurvey && this.survey.usuarios.length === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Si está registrando una encuesta masiva debe registrar en este momento al menos un usuario.';
            }
            else
            {
                bDataOK = true;
            }

            if (!this.bNew && bDataOK) {
                //Edición de encuesta...
                this.$store.dispatch('editSurvey', this.survey);
            } else if (this.bNew && bDataOK) {
                //Registro de nueva encuesta...
                this.bNew = false;

                if (this.bMultipleSurvey) {
                    this.$store.dispatch('saveNewMultipleSurvey', this.survey);
                    this.bMultipleSurvey = false;
                } else {
                    this.$store.dispatch('saveNewSurvey', this.survey);
                }
            }

            if (bDataOK) {
                this.selectedSurveyName = this.survey.nombreEncuesta;
                this.bEdit = false;
            }
        },
        selectFirstSurvey() {
            //console.log('selectFistSet, ', this.surveys);
            if (this.surveys.length > 0) {
                this.selectedSurveyIndex = 0;
                var surveyID = this.surveys[this.selectedSurveyIndex].encuestaID;
                this.selectSurvey(surveyID);
            } else {
                this.selectedSurveyIndex = -1;
                this.survey.encuestaID = 0;
            }
        },
        selectSurvey(surveyID)
        {
            this.loadingSurvey = true; //Para no dejar seleccionar otra encuesta antes de que se haya terminado de cargar toda la información.
            this.$store.dispatch('getSurveyData', surveyID);
            this.selectedUser = [];
        },

        onSendStatus()
        {
            if (!this.survey.mandarEstados) {
                this.survey.mandarEstadosDias = 0;
            }
        },

        onSendReminders()
        {
            //     console.log('onSendReminders');
            //     if (this.bEdit) {
            //         this.sendReminders = !this.sendReminders;
            //     }
            //     console.log('Reminders = ', this.reminders);
            if (!this.survey.mandarRecordatorios)
            {
                this.survey.mandarRecordatoriosDias = 0;
            }
        },

        onShowDemographics()
        {
            if (!this.survey.mostrarDemograficos)
            {
                this.survey.minimoDemograficos = 0;
            }
        },

        onSelectCompany()
        {
            //Obtiene el logo de la empresa seleccionada:
            var j;
            for (j = 0; j < this.companies.length; j++) {
                if (this.survey.empresaID === this.companies[j].empresaid) {
                    this.logoInfo = this.companies[j].logoInfo;
                    if (this.logoInfo.id === null) {
                        this.bLogo = false;
                        this.companyLogoImg = require('@/assets/no-logo.png');
                    } else {
                        this.bLogo = true;
                        this.$store.dispatch('getCompanyLogo', this.logoInfo);
                    }

                    break;
                }
            }
        },

        onSelectQuestionnaire() {
            //Crea un arreglo con los idiomas registrados para el cuestionario seleccionado, y selecciona el set de
            //respuestas del cuestionario:
            this.questionnaireLanguages = [];
            var i;

            this.survey.envioMailReporte = '0';

            for (i = 0; i < this.questionnaires.length; i++)
            {
                if (this.questionnaires[i].id === this.survey.cuestionarioID)
                {
                    this.answerSetID = this.questionnaires[i].setrespuestasid;

                    console.log('questionnaires[i] = ', this.questionnaires[i]);

                    if (this.questionnaires[i].masiva)
                    {
                        this.bAllowMultipleSurvey = true;
                    }
                    else
                    {
                        this.bAllowMultipleSurvey = false;
                    }

                    if (this.questionnaires[i].envioReporte)
                    {
                        this.bEnvioReporte = true;
                    }
                    else
                    {
                        this.bEnvioReporte = false;
                    }

                    var j;

                    //Si el cuestionario tiene competencias, entonces si answerSetID !== 0 hay que buscar el nombre del
                    //set de respuestas.

                    if (this.questionnaires[i].competencias)
                    {
                        this.bShowAnswerSet = true;
                        //Si answerSetID === 0, quiere decir que el set de respuestas es por pregunta:
                        if (this.answerSetID === 0)
                        {
                            this.answerSetName = 'Por pregunta';
                        } //Busca el nombre del set de respuestas...
                        else
                        {
                            for (j = 0; j < this.answerSets.length; j++)
                            {
                                if (this.answerSetID === this.answerSets[j].setrespuestasid)
                                {
                                    this.answerSetName = this.answerSets[j].nombre;
                                    break;
                                }
                            }
                        }
                    } //El cuestionario no tiene competencias, por lo que tampoco tiene set de respuestas:
                    else
                    {
                        this.bShowAnswerSet = false;
                    }

                    //Crea el arreglo con los idiomas del cuestionario:
                    for (j = 0; j < this.questionnaires[i].idiomas.length; j++)
                    {
                        var langName;
                        var k;
                        for (k = 0; k < this.languages.length; k++)
                        {
                            if (this.questionnaires[i].idiomas[j].idiomaid === this.languages[k].idiomaid)
                            {
                                langName = this.languages[k].idioma;
                                break;
                            }
                        }
                        var lang = {
                            languageID: this.questionnaires[i].idiomas[j].idiomaid,
                            langName: langName,
                            selected: false,
                        };

                        //Se busca si el idioma está seleccionado:
                        var x;
                        for (x = 0; x < this.survey.idiomas.length; x++)
                        {
                            if (lang.languageID === this.survey.idiomas[x])
                            {
                                lang.selected = true;
                            }
                        }
                        this.questionnaireLanguages.push(lang);
                    }

                    //Si el cuestionario seleccionado tiene módulos de Equipos, crea un arreglo con todos los módulos sin seleccionar:
                    this.questionnaireModules = [];
                    if (this.questionnaires[i].modulosEquipo)
                    {
                        this.bModules = true;
                        //Crea el arreglo con los módulos del cuestionario:
                        for (j = 0; j < this.surveyQuestModulesTeams.length; j++)
                        {
                            var questModule = {
                                moduleID: this.surveyQuestModulesTeams[j].moduloid,
                                module: this.surveyQuestModulesTeams[j].modulo,
                                groupID: this.surveyQuestModulesTeams[j].grupoid,
                                selected: false,
                            };

                            //Se busca si el módulo está seleccionado:
                            var x;
                            for (x = 0; x < this.survey.modulos.length; x++)
                            {
                                if (questModule.moduleID == this.survey.modulos[x])
                                {
                                    questModule.selected = true;
                                }
                            }
                            this.questionnaireModules.push(questModule);
                        }
                        console.log('questionnaireModules = ', this.questionnaireModules);
                    }
                    else
                    if (this.questionnaires[i].modulosCultura)
                    {
                        this.bModules = true;
                        //Crea el arreglo con los módulos del cuestionario:
                        for (j = 0; j < this.surveyQuestModulesCulture.length; j++)
                        {
                            var questModule = {
                                moduleID: this.surveyQuestModulesCulture[j].moduloid,
                                module: this.surveyQuestModulesCulture[j].modulo,
                                groupID: this.surveyQuestModulesCulture[j].grupoid,
                                selected: false,
                            };

                            //Se busca si el módulo está seleccionado:
                            var x;
                            for (x = 0; x < this.survey.modulos.length; x++) {
                                if (questModule.moduleID == this.survey.modulos[x]) {
                                    questModule.selected = true;
                                }
                            }

                            this.questionnaireModules.push(questModule);
                        }
                        console.log('questionnaireModules = ', this.questionnaireModules);
                    }
                    else
                    {
                        this.bModules = false;
                    }

                    //Se construyen los headers para las tablas de categorías y cortes, los cuales dependen de la cantidad
                    //de idiomas configurados para el cuestionario seleccionado:
                    this.categoryHeader = [];

                    console.log('Creando header, survey = ', this.survey);
                    console.log('Creando header, survey.categorias = ', this.survey.categorias);

                    //if (typeof(this.survey.categorias) !== 'undefined')
                    //{
                        this.categoryToEditTemplate = [];
                        this.segmentToEditTemplate = [];

                        //if (this.survey.categorias.length === 0)
                        //{
                            for (j = 0; j < this.questionnaireLanguages.length; j++)
                            {
                                var columnCat = {
                                    text: this.questionnaireLanguages[j].langName,
                                    value: this.questionnaireLanguages[j].languageID.toString(),
                                    sortable: false,
                                    align: 'center',
                                    divider: true,
                                };

                                this.categoryHeader.push(columnCat);

                               //La tabla para el header de los cortes es igual a la anterior, pero incluye una columna para
                               //el número de corte (al principio) y dos columnas al final para borrar y editar:
                               this.segmentHeader = JSON.parse(JSON.stringify(this.categoryHeader));
                               const segmentNumberColumn = {
                                   text: 'Número',
                                   value: 'num',
                                   sortable: false,
                                   width: '2%',
                                   align: 'center',
                                   divider: true
                               }

                               //Agrega la columna para el número de corte al principio:
                               this.segmentHeader.splice(0, 0, segmentNumberColumn);

                               //Agrega las columnas para los botones de edición y borrado al final:
                                const editBtnColumn = {
                                    text: '',
                                    value: 'editBtn',
                                    sortable: false,
                                    width: '5%',
                                    divider: true,
                                    align: 'center'
                                };
                                this.segmentHeader.push(editBtnColumn);

                                 const deleteBtnColumn = {
                                    text: '',
                                    value: 'deleteBtn',
                                    sortable: false,
                                    width: '5%',
                                    divider: true,
                                    align: 'center'
                                };
                                this.segmentHeader.push(deleteBtnColumn);

                                var category = {
                                    idiomaID: this.questionnaireLanguages[j].languageID,
                                    idioma: this.questionnaireLanguages[j].langName,
                                    categoria: '',
                                };

                                var segment = {
                                    idiomaID: this.questionnaireLanguages[j].languageID,
                                    idioma: this.questionnaireLanguages[j].langName,
                                    segmento: '',
                                };

                                this.categoryToEditTemplate.push(category);
                                this.segmentToEditTemplate.push(segment);
                            }

                            //console.log("En onSelectQuestionnaire, categoryToEditTemplate = ", this.categoryToEditTemplate);
                            //console.log("En onSelectQuestionnaire, segmentToEditTemplate = ", this.segmentToEditTemplate)
                        //}
                    //}

                    break;
                }
            }
            //console.log('this.questionnaireLanguages = ', this.questionnaireLanguages);
        },

        getSurveyCreatorName() {
            this.surveyCreatorName = '';
            var i;

            console.log('users = ', this.users);
            console.log('survey.adminCreatorID = ', this.survey.adminCreadorID);

            for (i = 0; i < this.users.length; i++) {
                if (this.users[i].usuarioid === this.survey.adminCreadorID) {
                    this.surveyCreatorName =
                        this.users[i].appaterno +
                        ' ' +
                        this.users[i].apmaterno +
                        ' ' +
                        this.users[i].nombre;
                    break;
                }
            }
        },

        onSelectLanguage(languageID) {
            //console.log('questionnaireLanguages = ', this.questionnaireLanguages);
            var i;
            for (i = 0; i < this.questionnaireLanguages.length; i++) {
                if (this.questionnaireLanguages[i].languageID === languageID) {
                    //Si el idioma está seleccionado, lo agrega al arreglo de idiomas de la encuesta.
                    //Si no está seleccionado, lo borra del arreglo de idiomas de la encuesta.
                    if (this.questionnaireLanguages[i].selected) {
                        var j;

                        //Si el idioma ya estaba, no hace nada:
                        var bFound = false;
                        for (j = 0; j < this.survey.idiomas.length; j++) {
                            if (this.survey.idiomas[j] === languageID) {
                                bFound = true;
                                break;
                            }
                        }
                        if (!bFound) {
                            this.survey.idiomas.push(languageID);
                        }
                        break;
                    } else {
                        var j;
                        for (j = 0; j < this.survey.idiomas.length; j++) {
                            if (this.survey.idiomas[j] === languageID) {
                                this.survey.idiomas.splice(j, 1);
                                break;
                            }
                        }
                        break;
                    }
                }
            }
        },

        onSelectModule(moduleID) {
            //console.log('questionnaireModules = ', this.questionnaireModules);
            //console.log('moduleID = ', moduleID);
            var groupID = 0;
            var i;

            //Primero obtiene el grupoID del cuestionario seleccionado:
            for (i = 0; i < this.questionnaireModules.length; i++)
            {
                if (this.questionnaireModules[i].moduleID === moduleID)
                {
                    groupID = this.questionnaireModules[i].groupID;
                    break;
                }
            }

            //console.log('groupID = ', groupID);

            for (i = 0; i < this.questionnaireModules.length; i++)
            {
                if (this.questionnaireModules[i].moduleID === moduleID)
                {
                    //Si el módulo está seleccionado, lo agrega al arreglo de módulos de la encuesta.
                    //Si no está seleccionado, lo borra del arreglo de módulos de la encuesta.
                    if (this.questionnaireModules[i].selected)
                    {
                        var j;

                        //Si el módulo ya estaba, no hace nada:
                        var bFound = false;
                        for (j = 0; j < this.survey.modulos.length; j++)
                        {
                            if (this.survey.modulos[j] === moduleID)
                            {
                                bFound = true;
                                break;
                            }
                        }
                        if (!bFound)
                        {
                            this.survey.modulos.push(moduleID);
                        }
                        //break;
                    }
                    else
                    {
                        var j;
                        for (j = 0; j < this.survey.modulos.length; j++)
                        {
                            if (this.survey.modulos[j] === moduleID)
                            {
                                this.survey.modulos.splice(j, 1);
                                break;
                            }
                        }
                        //break;
                    }
                }
                //Nada más puede haber un módulo con el mismo grupoID (grupoID = 1 quiere decir que no hay grupo).
                //Por lo tanto, si grupoID del módulo seleccionado es diferente de "1", desselecciona a los otros módulos
                //que tengan el mismo grupoID.
                else //this.questionnaireModules[i].moduleID !== moduleID
                {
                    if ((this.questionnaireModules[i].groupID !== 1) &&
                        (this.questionnaireModules[i].groupID !== 0) &&
                        (this.questionnaireModules[i].groupID === groupID))
                    {
                        this.questionnaireModules[i].selected = false;

                        var j;
                        for (j = 0; j < this.survey.modulos.length; j++)
                        {
                            if (this.survey.modulos[j] === this.questionnaireModules[i].moduleID)
                            {
                                this.survey.modulos.splice(j, 1);
                                break;
                            }
                        }
                    }
                }
            }
            //console.log("this.survey.modulos = ", this.survey.modulos);
        },

        onSearch() {
            if (this.searchText !== '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
               
                for (i = 0; i < this.surveys.length; i++)
                {
                    var strLowerCaseText = this.surveys[i].nombreEncuesta.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0) {
                        this.selectedSurveyIndex = i;
                        this.selectSurvey(this.surveys[i].encuestaID);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },
        onAddUser() {
            this.editingUserID = 0;
            this.editingUserNumber = this.survey.usuarios.length + 1;
            this.editingUserName = '';
            this.editingUserEmail = '';
            this.editingUserRolleID = 0;
            this.editingUserAccessNumber = 0;
            this.editingUserReport = true;

            this.bNewUser = true;
            this.bDlgEditUser = true;

            console.log("surveyRolleLabels = ", this.surveyRolleLabels);
        },
        onEditUser() {
            //console.log('selectedUser = ', this.selectedUser);

            this.editingUserID = this.selectedUser[0].usuarioID;
            this.editingUserNumber = this.selectedUser[0].num;
            this.editingUserName = this.selectedUser[0].nombre;
            this.editingUserEmail = this.selectedUser[0].correo;
            this.editingUserRolleID = this.selectedUser[0].rolID;
            this.editingUserAccessNumber = this.selectedUser[0].accesos;
            this.editingUserReport = this.selectedUser[0].reporte;

            this.bNewUser = false;
            this.bDlgEditUser = true;
        },
        onConfirmUserEdition() {
            var bDataOK = false;

            //Validadión de datos:
            if (this.editingUserName === '') {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el nombre del usuario.';
            } else if (this.editingUserEmail === '') {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el correo electrónico del usuario.';
            } else if (this.editingUserRolleID === 0) {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione el rol del usuario.';
            } else if ((this.editingUserRolleID === 2) && (this.editingUserAccessNumber < 1))
            {
                this.bInvalidData = true;
                this.errorMessage = 'El número de accesos no puede ser menor a 1.';
            }
            else {
                bDataOK = true;
            }

            if (!this.bNewUser && bDataOK) {
                //Edición de usuario:
                var i;
                //console.log('this.editingUserID = ', this.editingUserID);
                //console.log('usuarios = ', this.survey.usuarios);

                for (i = 0; i < this.survey.usuarios.length; i++) {
                    if (this.survey.usuarios[i].usuarioID === this.editingUserID) {
                        this.survey.usuarios[i].nombre = this.editingUserName;
                        this.survey.usuarios[i].correo = this.editingUserEmail;
                        this.survey.usuarios[i].rolID = this.editingUserRolleID;
                        this.survey.usuarios[i].accesos = this.editingUserAccessNumber;
                        this.survey.usuarios[i].reporte = this.editingUserReport;

                        break;
                    }
                }

                this.$store.dispatch('editSurveyUser', this.survey.usuarios[i]);
                console.log("Usuario a editar: ", this.survey.usuarios[i]);

                //Actualiza la etiqueta del rol del usuario editado:
                //console.log('this.surveyUserTable = ', this.surveyUserTable);
                //console.log('this.surveyRolleLabels = ', this.surveyRolleLabels);

                for (i = 0; i < this.surveyUserTable.length; i++) {
                    if (this.surveyUserTable[i].usuarioID === this.editingUserID) {
                        this.surveyUserTable[i].nombre = this.editingUserName;
                        this.surveyUserTable[i].correo = this.editingUserEmail;
                        this.surveyUserTable[i].reporte = this.editingUserReport;
                        this.surveyUserTable[i].rolID = this.editingUserRolleID;
                        this.surveyUserTable[i].accesos = this.editingUserAccessNumber;
                        var j;
                        for (j = 0; j < this.surveyRolleLabels.length; j++) {
                            if (this.surveyRolleLabels[j].rolleID === this.editingUserRolleID) {
                                this.surveyUserTable[i].rol = this.surveyRolleLabels[j].label;
                                break;
                            }
                        }
                        break;
                    }
                }
            } else if (this.bNewUser && bDataOK) {
                //Registro de nuevo usuario:
                var newUser = {
                    usuarioID: 0,
                    num: this.survey.usuarios.length + 1,
                    nombre: this.editingUserName,
                    correo: this.editingUserEmail,
                    rolID: this.editingUserRolleID,
                    estado: 'Pendiente',
                    password: '',
                    accesos: this.editingUserAccessNumber,
                    reporte: this.editingUserReport,
                };
                this.survey.usuarios.push(newUser);

                var newTableUser = {
                    usuarioID: 0,
                    num: this.survey.usuarios.length + 1,
                    nombre: this.editingUserName,
                    correo: this.editingUserEmail,
                    rolID: this.editingUserRolleID,
                    rol: '',
                    estado: 'Pendiente',
                    password: '',
                    reporte: this.editingUserReport,
                };

                var j;
                for (j = 0; j < this.surveyRolleLabels.length; j++) {
                    if (this.surveyRolleLabels[j].rolleID === newTableUser.rolID) {
                        newTableUser.rol = this.surveyRolleLabels[j].label;
                        break;
                    }
                }
                this.surveyUserTable.push(newTableUser);

                this.bNewUser = false;

                const newUserObject = {
                    user: newUser,
                    surveyID: this.survey.encuestaID,
                };

                console.log('newUserObject = ', newUserObject);

                this.$store.dispatch('addSurveyUser', newUserObject);
            }

            //console.log('surveyUserTable = ', this.surveyUserTable);

            if (bDataOK) {
                this.bDlgEditUser = false;
            }
        },
        onCanceUserEdition() {
            this.bDlgEditUser = false;
            this.bNewUser = false;
            this.editingUserID = 0;
        },
        onDeleteUser() {
            this.deletingUserID = this.selectedUser[0].usuarioID;
            this.deletingUserName = this.selectedUser[0].nombre;
            this.bDeletingUser = true;
        },

        onCancelDeleteUser() {
            this.bDeletingUser = false;
            this.deletingUserID = 0;
        },

        onConfirmDeleteUser() {
            const userObject = {
                surveyID: this.survey.encuestaID,
                userID: this.deletingUserID,
            };
            this.$store.dispatch('deleteSurveyUser', userObject);

            var i;
            for (i = 0; i < this.survey.usuarios.length; i++) {
                if (this.survey.usuarios[i].usuarioID === this.deletingUserID) {
                    this.survey.usuarios.splice(i, 1);
                    break;
                }
            }

            for (i = 0; i < this.surveyUserTable.length; i++) {
                if (this.surveyUserTable[i].usuarioID === this.deletingUserID) {
                    this.surveyUserTable.splice(i, 1);
                    break;
                }
            }

            this.bDeletingUser = false;
            this.deletingUserID = 0;
            this.selectedUser = [];
        },

        onChangePassword() {
            this.changePasswdUserID = this.selectedUser[0].usuarioID;
            this.changePasswdUserName = this.selectedUser[0].nombre;
            this.bChangingUserPasswd = true;
        },

        onCancelChangePassword() {
            this.changePasswdUserID = 0;
            this.changePasswdUserName = '';
            this.bChangingUserPasswd = false;
        },

        onConfirmChangePassword() {
            console.log('onConfirmChangePassword');
            const userObject = {
                surveyID: this.survey.encuestaID,
                userID: this.changePasswdUserID,
            };
            this.$store.dispatch('changeSurveyUserPasswd', userObject);

            this.changePasswdUserID = 0;
            this.changePasswdUserName = '';
            this.bChangingUserPasswd = false;
        },

        onSendUserInvitation() {
            this.sendInvitationUserID = this.selectedUser[0].usuarioID;
            this.sendInvitationUserName = this.selectedUser[0].nombre;
            this.bSendingUserInvitation = true;
        },

        onCancelSendUserInvitation() {
            this.sendInvitationUserID = 0;
            this.sendInvitationUserName = '';
            this.bSendingUserInvitation = false;
        },

        onConfirmSendUserInvitation() {
            console.log('onConfirmSendUserInvitation');
            const userObject = {
                surveyID: this.survey.encuestaID,
                userID: this.sendInvitationUserID,
            };
            this.$store.dispatch('sendSurveyUserInvitation', userObject);

            this.sendInvitationUserID = 0;
            this.sendInvitationUserName = '';
            this.bSendingUserInvitation = false;
        },

        onSendSurveyInvitations() {
            this.bSendingSurveyInvitations = true;
        },

        onCancelSendSurveyInvitations() {
            this.bSendingSurveyInvitations = false;
        },

        onConfirmSendSurveyInvitations() {
            console.log('send Survey Invitations...');
            if (this.userType === 1 || this.userType === 2) {
                if (this.survey.invitacionMandada === false) {
                    console.log('Mandar invitación...');
                    this.$store.dispatch('sendSurveyInvitations', this.survey.encuestaID);
                }
            }
            this.bSendingSurveyInvitations = false;
        },

        onProcessReport() {
            this.reportLanguageID = '1'; //Español por default.
            this.bProcessReportDlg = true;
        },

        onConfirmProcessReport() {
            const reportInfo = {
                surveyID: this.survey.encuestaID,
                languageID: this.reportLanguageID
            };

            this.$store.dispatch('processReport', reportInfo);
            this.bProcessReportDlg = false;
        },

        onCancelProcessReport() {
            this.bProcessReportDlg = false;
        },

        onExcelExport()
        {
            this.bExcelExportDlg = true;
        },

        onConfirmExcelExport()
        {
            this.$store.dispatch('excelExport', this.survey.encuestaID);
            this.bExcelExportDlg = false;
        },

         onCancelExcelExport() {
            this.bExcelExportDlg = false;
        },

        onHypotheticalReport() {
            const reportInfo = {
                surveyID: this.survey.encuestaID,
                languageID: this.reportLanguageID,
                retroalimentado: '1',
            };

            this.$store.dispatch('processReport', reportInfo);

            this.bNotMainUserAnswer = false;
        },

        onEditCategory(categoryID, categoryNumber)
        {
            this.editingCategoryID = categoryID;
            this.editingCategoryNumber = categoryNumber;

            var i;
            for (i = 0; i < this.survey.categorias.length; i ++)
            {
                if (this.survey.categorias[i].categoriaID === this.editingCategoryID)
                {
                    var j;
                    for (j = 0; j < this.survey.categorias[i].nombres.length; j ++)
                    {
                        var k;
                        for (k = 0; k < this.categoryToEdit.length; k ++)
                        {
                            if (this.survey.categorias[i].nombres[j].idiomaID === this.categoryToEdit[k].idiomaID)
                            {
                                this.categoryToEdit[k].categoria = this.survey.categorias[i].nombres[j].categoria;
                                break;
                            }
                        }
                    }
                    break;
                }
            }
             this.bDlgEditCategory = true;
        },

        onConfirmEditCategory()
        {
            var i;
            for (i = 0; i < this.survey.categorias.length; i ++)
            {
                if (this.survey.categorias[i].categoriaID === this.editingCategoryID)
                {
                    var j;
                    for (j = 0; j < this.survey.categorias[i].nombres.length; j ++)
                    {
                        var k;
                        for (k = 0; k < this.categoryToEdit.length; k ++)
                        {
                            if (this.survey.categorias[i].nombres[j].idiomaID === this.categoryToEdit[k].idiomaID)
                            {
                                this.survey.categorias[i].nombres[j].categoria = this.categoryToEdit[k].categoria;
                                break;
                            }
                        }
                    }
                    break;
                }
            }

            for (i = 0; i < this.categoryNameTable.length; i ++)
            {
                if (this.categoryNameTable[i][0].id === this.editingCategoryID)
                {
                    
                    for (j = 0; j < this.categoryToEdit.length; j ++)
                    {
                        this.categoryNameTable[i][0][this.categoryToEdit[j].idiomaID] = this.categoryToEdit[j].categoria;
                    }
                    break;
                }
            }
            this.bDlgEditCategory = false;
        },

        onCancelEditCategory()
        {
            //Se pone en blanco el arreglo categoryToEdit:
            var i;
            for (i = 0; i < this.categoryToEdit.length; i++)
            {
                this.categoryToEdit[i].categoria = '';
            }

            this.bDlgEditCategory = false;
        },

        onEditSegment(category, segment)
        {
            this.editingCategoryID = category.categoriaID;
            this.editingSegmentID = segment.corteID;
            this.editingSegmentNumber = segment.num;

            //console.log("editingSetmentID = ", this.editingSegmentID);
            //console.log("category = ", category);

            var i;
            for (i = 0; i < category.cortes.length; i ++)
            {
                if (category.cortes[i].corteID === this.editingSegmentID)
                {
                    var j;
                    for (j = 0; j < category.cortes[i].nombres.length; j ++)
                    {
                        var k;
                        for (k = 0; k < this.segmentToEdit.length; k ++)
                        {
                            if (category.cortes[i].nombres[j].idiomaID === this.segmentToEdit[k].idiomaID)
                            {
                                this.segmentToEdit[k].segmento = category.cortes[i].nombres[j].segmento;
                                break;
                            }
                        }
                    }
                    break;
                }
            }
            this.bDlgEditSegment = true;
        },

        onConfirmEditSegment()
        {
            var i;
            for (i = 0; i < this.survey.categorias.length; i ++)
            {
                if (this.survey.categorias[i].categoriaID === this.editingCategoryID)
                {
                    var j;
                    for (j = 0; j < this.survey.categorias[i].cortes.length; j ++)
                    {
                        if (this.survey.categorias[i].cortes[j].corteID === this.editingSegmentID)
                        {
                            var k;
                            for (k = 0; k < this.survey.categorias[i].cortes[j].nombres.length; k ++)
                            {
                                var x;
                                for (x = 0; x < this.segmentToEdit.length; x ++)
                                {
                                    if (this.survey.categorias[i].cortes[j].nombres[k].idiomaID === this.segmentToEdit[x].idiomaID)
                                    {
                                        this.survey.categorias[i].cortes[j].nombres[k].segmento = this.segmentToEdit[x].segmento;
                                        break;
                                    }
                                }
                            }
                            break;
                        }
                    }
                    break;
                }
            }

            //Se vuelven a crear las tablas de todos los segmentos:
            this.createSegmentTables();

            this.bDlgEditSegment = false;
        },

        onCancelEditSegment()
        {
            //Se pone en blanco el arreglo segmentToEdit:
            var i;
            for (i = 0; i < this.segmentToEdit.length; i++)
            {
                this.segmentToEdit[i].segmento = '';
            }

            this.bDlgEditSegment = false;
        },

        onAddCategory()
        {
            if (this.survey.cuestionarioID !== 0)
            {
                //console.log('survey.categorias = ', this.survey.categorias);
                
                this.categoryToEdit = JSON.parse(JSON.stringify(this.categoryToEditTemplate));
                console.log("categoryToEditTemplate = ", this.categoryToEditTemplate);
                console.log("categoryToEdit = ", this.categoryToEdit);
                this.bDlgAddCategory = true;
            }
        },

        onConfirmAddCategory()
        {
            this.bDlgAddCategory = false;
            //Obtiene un ID temporal (negativo, para poder identificar en el serviddor que se trata de una categoría
            //nueva), igual a la longitud del arreglo de categorías más uno:
            var categoryIDTemp = -(this.survey.categorias.length + 1);
            var newCategoryName = JSON.parse(JSON.stringify(this.categoryToEdit));
            var newCategory = {
                categoriaID: categoryIDTemp,
                nombres: newCategoryName,
                cortes: [],
            };
            console.log("New category = ", newCategory);
            this.survey.categorias.push(newCategory);
            console.log('survey.categorias = ', this.survey.categorias);

            var nameOneRowTable = []; //Arreglo con un solo renglón, para la categoría, con una columna por idioma.
            var nameTableRow = {
                id: categoryIDTemp,
            };

            var i;
            for (i = 0; i < newCategory.nombres.length; i++)
            {
                const idiomaID = newCategory.nombres[i].idiomaID;
                nameTableRow[idiomaID] = newCategory.nombres[i].categoria;
            }

            console.log('nameTableRow = ', nameTableRow);
            console.log('categoryNameTable = ', this.categoryNameTable);

            nameOneRowTable.push(nameTableRow);
            this.categoryNameTable.push(nameOneRowTable);
        },

        onCancelAddCategory() {
            this.bDlgAddCategory = false;
        },

        onDeleteCategory(categoryID, categoryNumber)
        {
            this.deletingCategoryID = categoryID;
            this.deletingCategoryNumber = categoryNumber;

            this.bDlgDeletingCategory = true;
        },
        
        onCancelDeleteCategory()
        {
            this.deletingCategoryID = 0;
            this.deletingCategoryNumber = 0;

            this.bDlgDeletingCategory = false;
        },

        onConfirmDeleteCategory()
        {
            var i;
            for (i = 0; i < this.survey.categorias.length; i ++)
            {
                if (this.survey.categorias[i].categoriaID === this.deletingCategoryID)
                {
                    this.survey.categorias.splice(i, 1);
                    break;
                }
            }

            console.log("this.survey.categorias", this.survey.categorias)

            //Se vuelve a construir la tabla de competencias:
            this.createCategoryTables();

            this.deletingCategoryID = 0;
            this.deletingCategoryNumber = 0;
            this.bDlgDeletingCategory = false;
        },

        onAddSegment(categoryNumber)
        {
            if (this.survey.cuestionarioID !== 0)
            {
                this.editingCategoryNumber = categoryNumber;
                this.segmentToEdit = JSON.parse(JSON.stringify(this.segmentToEditTemplate));
                this.editingCategoryNumber;
                this.editingSegmentNumber = this.survey.categorias[categoryNumber].cortes.length + 1;
                this.bDlgAddSegment = true;
            }
        },

        onConfirmAddSegment()
        {
            this.bDlgAddSegment = false;

            //Obtiene un ID temporal (negativo, para poder identificar en el servidor que se trata de un corte
            //nuevo), igual a la longitud del arreglo de cortes de la categoría en edición más uno:
            console.log("editingCategoryNumber = ", this.editingCategoryNumber);
            var segmentIDTemp = -(this.survey.categorias[this.editingCategoryNumber].cortes.length + 1);
            var newSegmentName = JSON.parse(JSON.stringify(this.segmentToEdit));
            var newSegment = {
                corteID: segmentIDTemp,
                nombres: newSegmentName,
            };
            
            console.log("New segment = ", newSegment);

            this.survey.categorias[this.editingCategoryNumber].cortes.push(newSegment);
            console.log('survey.categorias = ', this.survey.categorias);
            console.log("survey = ", this.survey);

            this.createSegmentTables();
        },

        onCancelAddSegment()
        {
            this.bDlgAddSegment = false;
        },

        onDeleteSegment(category, categoryIndex, segment)
        {
            this.editingCategoryID = category.categoriaID;
            this.editingCategoryNumber = categoryIndex + 1;
            this.deletingSegmentID = segment.corteID;
            this.deletingSegmentNumber = segment.num;

            this.bDlgDeletingSegment = true;
        },

        onCancelDeleteSegment()
        {
            this.editingCategoryID =  0;
            this.editingCategoryNumber = 0;
            this.deletingSegmentID = 0;
            this.deletingSegmentNumber = 0;

            this.bDlgDeletingSegment = false;
        },

        onConfirmDeleteSegment()
        {
            console.log("editingCategoryID = ", this.editingCategoryID);
            console.log("deletingSegmentID = ", this.deletingSegmentID);

            var i;
            for (i = 0; i < this.survey.categorias.length; i ++)
            {
                if (this.survey.categorias[i].categoriaID === this.editingCategoryID)
                {
                    console.log("Se encontró la categoría en edición...");
                    var j;
                    for (j = 0; j < this.survey.categorias[i].cortes.length; j ++)
                    {
                        if (this.survey.categorias[i].cortes[j].corteID === this.deletingSegmentID)
                        {
                            console.log("Se encontró el corte a borrar....");
                            this.survey.categorias[i].cortes.splice(j, 1);
                            break;
                        }
                    }
                    break;
                }
            }

            //Se vuelve a construir la tabla de segmentos:
            this.createSegmentTables();

            this.editingCategoryID =  0;
            this.editingCategoryNumber = 0;
            this.deletingSegmentID = 0;
            this.deletingSegmentNumber = 0;

            this.bDlgDeletingSegment = false;

            console.log("this.survey.categorias = ", this.survey.categorias);
        },

        createCategoryTables()
        {
            this.categoryNameTable = [];
            var i;
            for (i = 0; i < this.survey.categorias.length; i ++)
            {
                var nameOneRowTable = []; //Arreglo con un solo renglón, para cada categoría, con una columna por idioma.
                var nameTableRow = {
                    id: this.survey.categorias[i].categoriaID,
                }

                var j;
                for (j = 0; j < this.survey.categorias[i].nombres.length; j ++)
                {
                    const idiomaID = this.survey.categorias[i].nombres[j].idiomaID;
                    nameTableRow[idiomaID] = this.survey.categorias[i].nombres[j].categoria;
                }

                nameOneRowTable.push(nameTableRow);
                this.categoryNameTable.push(nameOneRowTable);
            }
        },

        createSegmentTables()
        {
            this.categorySegmentTable = [];

            var i;
            for (i = 0; i < this.survey.categorias.length; i ++)
            {
                var segmentNumber = 0;
                var segmentTable = []; //Arreglo de segmentos para cada corte, con una columna por idioma.
                var j;
                for (j = 0; j < this.survey.categorias[i].cortes.length; j ++)
                {
                    var segmentTableRow = {
                        corteID: this.survey.categorias[i].cortes[j].corteID,
                        num: 0
                    };
                    var k;
                    for (k = 0; k < this.survey.categorias[i].cortes[j].nombres.length; k ++)
                    {
                        const idiomaID = this.survey.categorias[i].cortes[j].nombres[k].idiomaID;
                        segmentTableRow[idiomaID] = this.survey.categorias[i].cortes[j].nombres[k].segmento;
                    }

                    segmentNumber += 1;
                    segmentTableRow.num = segmentNumber;
                    segmentTable.push(segmentTableRow);
                }
                this.categorySegmentTable.push(segmentTable);
            }

            console.log("categorySegmentTable = ", this.categorySegmentTable);

        }
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'userType',
            'loggedUserID',
            'companyID',
            'questionnaireID',
            'users',
            'languages',
            'companies',
            'questionnaires',
            'answerSets',
            'surveyUserTable',
            'surveyRolleLabels',
            'surveyQuestModulesTeams',
            'surveyQuestModulesCulture',
        ]),

        noDataTextInternalAdmin() {
            var txt = '';
            if (this.survey.empresaID === 0) {
                txt = 'Seleccione una empresa';
            } else {
                txt = 'No hay administradores de seguimiento interno registrados para esta empresa';
            }
            return txt;
        },

        internalAdministrators() {
            var internalAdmins = [];
            var i;
            for (i = 0; i < this.users.length; i++) {
                //Busca los usuarios activos de la empresa seleccionada que sean admin. de seguimiento interno:
                if (
                    this.users[i].activo === 1 &&
                    this.users[i].empresaid === this.survey.empresaID &&
                    this.users[i].tipoid === 3
                ) {
                    var intAdminUser = {
                        name:
                            this.users[i].appaterno +
                            ' ' +
                            this.users[i].apmaterno +
                            ' ' +
                            this.users[i].nombre,
                        userID: this.users[i].usuarioid,
                    };
                    internalAdmins.push(intAdminUser);
                }
            }
            return internalAdmins;
        },

        companyLogoImg: {
            get() {
                return this.$store.getters.companyLogoImg;
            },
            set(companyLogoImg) {
                this.$store.dispatch('updateCompanyLogoImg', companyLogoImg);
            },
        },
        selectedSurveyIndex: {
            get() {
                return this.$store.getters.selectedSurveyIndex;
            },
            set(selectedSurveyIndex) {
                this.$store.dispatch('updateSelectedSurveyIndex', selectedSurveyIndex);
            },
        },

        surveys: {
            get() {
                return this.$store.getters.surveys;
            },
            set(surveys) {
                this.$store.dispatch('updateSurveys', surveys);
            },
        },

        survey: {
            get() {
                return this.$store.getters.survey;
            },
            set(surveys) {
                this.$store.dispatch('updateSurvey', survey);
            },
        },

        surveyLoaded: {
            get() {
                return this.$store.getters.surveyLoaded;
            },
            set(surveyLoaded) {
                this.$store.dispatch('updateSurveyLoaded', surveyLoaded);
            },
        },

        loadingSurvey: {
            get() {
                return this.$store.getters.loadingSurvey;
            },
            set(loadingSurvey) {
                this.$store.dispatch('updateLoadingSurvey', loadingSurvey);
            },
        },

        reportProcessed: {
            get() {
                return this.$store.getters.reportProcessed;
            },
            set(reportProcessed) {
                this.$store.dispatch('updateReportProcessed', reportProcessed);
            },
        },

        reportWarning: {
            get() {
                return this.$store.getters.reportWarning;
            },
            set(reportWarning) {
                this.$store.dispatch('updateReportWarning', reportWarning);
            },
        },

        pdfPath: {
            get() {
                return this.$store.getters.pdfPath;
            },
            set(pdfPath) {
                this.$store.dispatch('updatePdfPath', pdfPath);
            },
        },

        excelProcessed: {
            get() {
                return this.$store.getters.excelProcessed;
            },
            set(excelProcessed) {
                this.$store.dispatch('updateExcelProcessed', excelProcessed);
            },
        },

        pdfPath: {
            get() {
                return this.$store.getters.pdfPath;
            },
            set(pdfPath) {
                this.$store.dispatch('updatePdfPath', pdfPath);
            },
        },

        excelPath: {
            get() {
                return this.$store.getters.excelPath;
            },
            set(excelPath) {
                this.$store.dispatch('updateExcelPath', excelPath);
            },
        },

        surveyPercentage() {
            var percentage = 0;
            if (this.survey.usuarios.length != 0) {
                var percentage = 100 * (this.survey.numRespuestas / this.survey.usuarios.length);
                percentage = Number(percentage.toFixed(1));
            }
            return percentage;
        },

        progressColor() {
            var color;
            if (this.surveyPercentage < 20) {
                color = 'red darken-2';
            } else if (this.surveyPercentage < 40) {
                color = 'orange darken-3';
            } else if (this.surveyPercentage < 60) {
                color = 'yellow darken-3';
            } else if (this.surveyPercentage < 80) {
                color = 'lime darken-2';
            } else if (this.surveyPercentage < 100) {
                color = 'green';
            } else {
                color = 'teal';
            }
            return color;
        },

        surveyProgressClass() {
            var surveyClass;

            //surveyClass = 'grey--text text--darken-3 body-2';
            if (this.surveyPercentage < 20) {
                surveyClass = 'red--text text--darken-2 body-2';
            } else if (this.surveyPercentage < 40) {
                surveyClass = 'orange--text text--darken-3 body-2';
            } else if (this.surveyPercentage < 60) {
                surveyClass = 'yellow--text text--darken-3 body-2';
            } else if (this.surveyPercentage < 80) {
                surveyClass = 'lime--text text--darken-2 body-2';
            } else if (this.surveyPercentage < 100) {
                surveyClass = 'green--text body-2';
            } else {
                surveyClass = 'teal--text body-2';
            }
            return surveyClass;
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            } else {
                height = '900px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '50';
            } else if (this.$vuetify.breakpoint.md) {
                height = '65';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },
    },
    watch: {
        surveyLoaded: function (value, oldValue) {
            console.log('surveyLoaded oldValue: ', oldValue);
            console.log('surveyLoaded newValue: ', value);

            if (this.surveyLoaded) {
                this.getSurveyCreatorName();
                this.onSelectCompany();
                this.onSelectQuestionnaire();
                this.selectedSurveyName = this.survey.nombreEncuesta;

                //Se construye la tabla de categorías:
                this.categoryNameTable = [];
                //if (typeof(this.survey.categorias) !== "undefined")
                //{
                    var i;
                    for (i = 0; i < this.survey.categorias.length; i ++)
                    {
                        var nameOneRowTable = []; //Arreglo con un solo renglón, para cada categoría, con una columna por idioma.
                        var nameTableRow = {
                            id: this.survey.categorias[i].categoriaID,
                        }

                        var j;
                        for (j = 0; j < this.survey.categorias[i].nombres.length; j ++)
                        {
                            const idiomaID = this.survey.categorias[i].nombres[j].idiomaID;
                            nameTableRow[idiomaID] = this.survey.categorias[i].nombres[j].categoria;
                        }

                        nameOneRowTable.push(nameTableRow);
                        this.categoryNameTable.push(nameOneRowTable);
                    }

                    //console.log("categoryNameTable = ", this.categoryNameTable);
                    this.createSegmentTables();
                //}

                this.surveyLoaded = false;
            }
        },
        reportProcessed: function (value, oldValue) {
            console.log('Fuera del if, pdfPath = ', this.pdfPath);

            if (this.reportProcessed) {
                this.reportProcessed = false;

                console.log('ReportWarning = ', this.reportWarning);

                if (this.reportWarning === 0 && this.pdfPath !== '')
                {
                    console.log('path = ', this.pdfPath);
                    window.open(this.pdfPath);
                    this.pdfPath = '';
                } else if (this.reportWarning === 1) {
                    //El autorretroalimentado no ha contestado. Se pregunta si se desea generar un reporte hipotético.

                    this.reportWarning = 0;
                    this.bNotMainUserAnswer = true;
                    this.pdfPath = '';
                }
                if (this.reportWarning === 2) {
                    this.reportWarning = 0;
                    this.bReportNotCreated = true;
                    this.pdfPath = '';
                }
            }
        },
        excelProcessed: function (value, oldValue) {
            console.log('Fuera del if, excelPath = ', this.excelPath);

            if (this.excelProcessed) {
                this.excelProcessed = false;

                if (this.excelPath !== '')
                {
                    console.log('path = ', this.excelPath);
                    window.open(this.excelPath);
                    this.excelPath = '';
                } else {
                    this.bExcelNotCreated = true;
                }
            }
        },
    },
};
</script>

<style scoped>
.sub-window {
    background: rgba(224, 224, 224, 0.6);
}
.surveys {
    /* background: url('../assets/christina-wocintechchat-com-faEfWCdOKIg-unsplash.jpg'); */
    background: url('../assets/mainbackground.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>